// extracted by mini-css-extract-plugin
export default {"root":"bRlpRr","active":"SxNiiA","size-40":"rTHE1T","inner":"puiQqP","size-32":"_FhgU5"};